import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import DeleteLiveChannelOptions from '../DeleteLiveChannelOptions';

const ModalDeleteTVChannel = ({ data = {}, onSuccess = null, onCancel = null }) => {

    const modalProps = {
        childrenClassName: 'modal-delete-tv-channel'
    };
    
    return (
        <ModalWrapper {...modalProps}>
            <DeleteLiveChannelOptions
                data={data}
                onSuccess={onSuccess}
                onCancel={onCancel}
            />
        </ModalWrapper>
    );
};

export default withOnClose(ModalDeleteTVChannel);


// WEBPACK FOOTER //
// ./src/components/Modal/ModalDeleteTVChannel.jsx